/*
 * Copyright (c) 2018, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */


import React, { Component } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Security, LoginCallback } from '@okta/okta-react';
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js';
import config from './config';
import Home from './Home.jsx';
import Navbar from './Navbar.jsx';
import Footer from './Footer.jsx';
import Profile from './Profile.jsx';
import Result from './Result.jsx';
import Settings from './Settings.jsx';
import OrganizationChart from './OrganizationChart.jsx';

class App extends Component {
  constructor(props) {
    super(props);
    this.oktaAuth = new OktaAuth({
      issuer: config.env.oidc.issuer,
      clientId: config.env.oidc.clientId,
      redirectUri: config.env.oidc.redirectUri,
      scopes: config.env.oidc.scopes,
      pkce: true,
      responseType: 'code',
      tokenManager: {
        storage: 'memory' 
      }
    });
    this.state = {
      isAuthenticated: false
    }
    this.restoreOriginalUri = async (_oktaAuth, originalUri) => {
      const relative = toRelativeUrl('/', window.location.origin);
      window.history.replaceState(null, '', relative);
    };
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps?.authState && this.props?.authState && prevProps.authState.isAuthenticated !== this.props.authState.isAuthenticated) {
      this.setState({ isAuthenticated: this.props.authState?.isAuthenticated });
    }
  }

  render() {
    return (
      <Security oktaAuth={this.oktaAuth} restoreOriginalUri={this.restoreOriginalUri}>
        <div>
          <Navbar />
          <Routes>
            <Route path="/login/callback" element={<LoginCallback />} />
            <Route path="/" element={<Home />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/myprofile" element={<Profile />} />
            <Route path="/orgchart" element={<OrganizationChart />} />
            <Route path="/result" element={<Result />} />
            <Route path="/settings" element={<Settings />} />
          </Routes>
          <Footer />
        </div>
      </Security>
    );
  }
}
export default function RootApp() {
  return (
    <Router>
      <App />
    </Router>
  );
}
